<template>
  <div class="md-layout md-alignment-center-center">
    <div class="md-layout-item">
      <span class="md-title">{{ message }}</span>
    </div>
  </div>
</template>

<script>
import CommonMixin from "../../../mixins/commonMixin";

export default {
  name  : 'MessageDialog',
  props : {
    message: {
      type   : String,
      default: '',
    },
  },
  mixins: [CommonMixin],
  data  : () => ({}),
  mounted() {
  },
  watch  : {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.md-layout {
  position: fixed;
  top: 126px;
  left: 11px;
  width: 281px;
  display: flex;
  padding: 4px 8px;
  background-color: #fff;
  box-shadow: 0 0 8px #bbbbbb;
  border-radius: 4px;

  .md-title {
    font-size: 11px;
    font-weight: bold;
    display: flex;
    justify-content: center;
  }
}
</style>
